webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Input_vue__ = __webpack_require__(133);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c984c18_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Input_vue__ = __webpack_require__(236);
function injectStyle (ssrContext) {
  __webpack_require__(234)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c984c18"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c984c18_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Input_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set_immediate__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Canvas_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LoginDialog_vue__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SignUpDialog_vue__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UserSettingsDialog_vue__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_help_dialog_KeyPartnersHelpDialog_vue__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_help_dialog_KeyResourcesHelpDialog_vue__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_help_dialog_KeyActivitiesHelpDialog_vue__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_help_dialog_ValuePropositionsHelpDialog_vue__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_help_dialog_CustomerRelationshipsHelpDialog_vue__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_help_dialog_ChannelsHelpDialog_vue__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_help_dialog_CustomerSegmentsHelpDialog_vue__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_help_dialog_CostStructureHelpDialog_vue__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_help_dialog_RevenueStreamsHelpDialog_vue__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_AnalyticsService_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_PersistService_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_AuthService_js__ = __webpack_require__(152);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















var DEFAULT_CANVAS = [{
  id: __WEBPACK_IMPORTED_MODULE_2_uuid__["v4"](),
  name: "My first canvas",
  items: {},
  color: "#F56991"
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_18__services_AuthService_js__["a" /* AuthService */].subscribeUser(this.$firebase).subscribe(function (user) {
      _this.user = user;
      __WEBPACK_IMPORTED_MODULE_17__services_PersistService_js__["a" /* PersistService */].getModel(_this.$firebase).then(function (model) {
        if (_this.user && _this.user.uid && _this.canvas.length) {
          _this.canvas = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this.canvas), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(model));
        } else {
          _this.canvas = model || DEFAULT_CANVAS;
        }
      });
    });
  },
  data: function data() {
    return {
      selectedCanvasIdx: 0,
      canvas: [],
      isLogInDialogVisible: false,
      isSignUpDialogVisible: false,
      user: {},
      isUserSettingsVisible: false,
      selectedTopicHelp: null,
      isAsideVisible: false
    };
  },

  methods: {
    onClickOnNav: function onClickOnNav() {
      this.isAsideVisible = !this.isAsideVisible;
    },
    onClickOnCanvasComponent: function onClickOnCanvasComponent() {
      if (this.canvas.length && this.selectedCanvasIdx >= 0) {
        this.isAsideVisible = false;
      }
    },
    onClickOnCanvas: function onClickOnCanvas(idx) {
      this.selectedCanvasIdx = idx;
    },
    onClickOnAddCanvas: function onClickOnAddCanvas() {
      this.canvas.push({
        id: __WEBPACK_IMPORTED_MODULE_2_uuid__["v4"](),
        name: "My canvas " + (this.canvas.length + 1),
        items: {},
        color: "#F56991"
      });
      __WEBPACK_IMPORTED_MODULE_16__services_AnalyticsService_js__["a" /* AnalyticsService */].onCreateCanvas();
    },
    onItemDeleted: function onItemDeleted(group, index) {
      this.canvas[this.selectedCanvasIdx].items[group].splice(index, 1);
      __WEBPACK_IMPORTED_MODULE_16__services_AnalyticsService_js__["a" /* AnalyticsService */].onDeleteCanvasItem();
    },
    onItemCreated: function onItemCreated(group, label) {
      if (!this.canvas[this.selectedCanvasIdx].items[group]) {
        this.$set(this.canvas[this.selectedCanvasIdx].items, group, []);
      }
      this.canvas[this.selectedCanvasIdx].items[group].push({
        id: __WEBPACK_IMPORTED_MODULE_2_uuid__["v4"](),
        label: label
      });
      __WEBPACK_IMPORTED_MODULE_16__services_AnalyticsService_js__["a" /* AnalyticsService */].onCreateCanvasItem();
    },
    onCanvasTitleEdited: function onCanvasTitleEdited(title) {
      this.canvas[this.selectedCanvasIdx].name = title;
      __WEBPACK_IMPORTED_MODULE_16__services_AnalyticsService_js__["a" /* AnalyticsService */].onRenameCanvas();
    },
    onCanvasColorEdited: function onCanvasColorEdited(color) {
      this.canvas[this.selectedCanvasIdx].color = color;
      __WEBPACK_IMPORTED_MODULE_16__services_AnalyticsService_js__["a" /* AnalyticsService */].onChangeColorCanvas();
    },
    onCanvasDeleted: function onCanvasDeleted() {
      this.canvas.splice(this.selectedCanvasIdx, 1);
      this.selectedCanvasIdx = 0;
      __WEBPACK_IMPORTED_MODULE_16__services_AnalyticsService_js__["a" /* AnalyticsService */].onDeleteCanvas();
    },
    persist: function persist(model) {
      __WEBPACK_IMPORTED_MODULE_17__services_PersistService_js__["a" /* PersistService */].setModel(this.$firebase, model);
    },
    onClickOnLogIn: function onClickOnLogIn() {
      var _this2 = this;

      if (this.isLogInDialogVisible) {
        this.isLogInDialogVisible = false;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set_immediate___default()(function () {
        _this2.isLogInDialogVisible = true;
      });
    },
    onClickOnUserSettings: function onClickOnUserSettings() {
      this.isUserSettingsVisible = true;
    },
    onClickOnSignUp: function onClickOnSignUp() {
      this.isSignUpDialogVisible = true;
    },
    onSignedUp: function onSignedUp(user) {
      this.user = {
        email: user.email,
        uid: user.uid
      };
      this.isSignUpDialogVisible = false;
      __WEBPACK_IMPORTED_MODULE_16__services_AnalyticsService_js__["a" /* AnalyticsService */].onSignedUp();
    },
    onLogedIn: function onLogedIn(user) {
      this.isLogInDialogVisible = false;
      __WEBPACK_IMPORTED_MODULE_16__services_AnalyticsService_js__["a" /* AnalyticsService */].onLogedIn();
    },
    onLoginDialogClosed: function onLoginDialogClosed() {
      this.isLoginDialogVisible = false;
    },
    onSignUpDialogClosed: function onSignUpDialogClosed() {
      this.isSignUpDialogVisible = false;
    },
    onUserSettingsClosed: function onUserSettingsClosed() {
      this.isUserSettingsVisible = false;
    },
    onClickOnSignOut: function onClickOnSignOut() {
      this.canvas = [];
      __WEBPACK_IMPORTED_MODULE_18__services_AuthService_js__["a" /* AuthService */].signOut(this.$firebase);
      __WEBPACK_IMPORTED_MODULE_16__services_AnalyticsService_js__["a" /* AnalyticsService */].onLogedOut();
    },
    onAccountDeleted: function onAccountDeleted() {
      this.isUserSettingsVisible = false;
      this.canvas = [];
      __WEBPACK_IMPORTED_MODULE_16__services_AnalyticsService_js__["a" /* AnalyticsService */].onAccountDeleted();
    },
    onClickOnHelp: function onClickOnHelp(item) {
      this.selectedTopicHelp = item;
    },
    onCloseHelpDialog: function onCloseHelpDialog() {
      this.selectedTopicHelp = null;
    },
    onClickOnFeedback: function onClickOnFeedback() {
      __WEBPACK_IMPORTED_MODULE_16__services_AnalyticsService_js__["a" /* AnalyticsService */].onClickOnFeedback();
    }
  },
  computed: {
    selectedCanvas: function selectedCanvas() {
      return this.canvas[this.selectedCanvasIdx] || {};
    }
  },
  watch: {
    canvas: {
      deep: true,
      handler: function handler(model) {
        this.persist(model);
        if (!model.length) {
          this.isAsideVisible = true;
        }
      }
    }
  },
  components: {
    Canvas: __WEBPACK_IMPORTED_MODULE_3__components_Canvas_vue__["a" /* default */],
    LoginDialog: __WEBPACK_IMPORTED_MODULE_4__components_LoginDialog_vue__["a" /* default */],
    SignUpDialog: __WEBPACK_IMPORTED_MODULE_5__components_SignUpDialog_vue__["a" /* default */],
    UserSettingsDialog: __WEBPACK_IMPORTED_MODULE_6__components_UserSettingsDialog_vue__["a" /* default */],
    KeyPartnersHelpDialog: __WEBPACK_IMPORTED_MODULE_7__components_help_dialog_KeyPartnersHelpDialog_vue__["a" /* default */],
    KeyResourcesHelpDialog: __WEBPACK_IMPORTED_MODULE_8__components_help_dialog_KeyResourcesHelpDialog_vue__["a" /* default */],
    KeyActivitiesHelpDialog: __WEBPACK_IMPORTED_MODULE_9__components_help_dialog_KeyActivitiesHelpDialog_vue__["a" /* default */],
    ValuePropositionsHelpDialog: __WEBPACK_IMPORTED_MODULE_10__components_help_dialog_ValuePropositionsHelpDialog_vue__["a" /* default */],
    CustomerRelationshipsHelpDialog: __WEBPACK_IMPORTED_MODULE_11__components_help_dialog_CustomerRelationshipsHelpDialog_vue__["a" /* default */],
    ChannelsHelpDialog: __WEBPACK_IMPORTED_MODULE_12__components_help_dialog_ChannelsHelpDialog_vue__["a" /* default */],
    CustomerSegmentsHelpDialog: __WEBPACK_IMPORTED_MODULE_13__components_help_dialog_CustomerSegmentsHelpDialog_vue__["a" /* default */],
    CostStructureHelpDialog: __WEBPACK_IMPORTED_MODULE_14__components_help_dialog_CostStructureHelpDialog_vue__["a" /* default */],
    RevenueStreamsHelpDialog: __WEBPACK_IMPORTED_MODULE_15__components_help_dialog_RevenueStreamsHelpDialog_vue__["a" /* default */]
  }
});

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Canvas_vue__ = __webpack_require__(130);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be28861c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Canvas_vue__ = __webpack_require__(278);
function injectStyle (ssrContext) {
  __webpack_require__(228)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Canvas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_be28861c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Canvas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CanvasItem_vue__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_dialog__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Input_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_AnalyticsService_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_PdfExportService_js__ = __webpack_require__(246);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "bmcanvas",
  props: ["name", "items", "id", "color"],
  data: function data() {
    return {
      dialog: null,
      deleteConfirmDialog: null,
      editTitleModel: this.name,
      editColorModel: this.color || '#F56991'
    };
  },
  mounted: function mounted() {
    this.dialog = new __WEBPACK_IMPORTED_MODULE_1__material_dialog__["MDCDialog"](this.$el.querySelector("#canvas-title-edit-dialog"));
    this.colorDialog = new __WEBPACK_IMPORTED_MODULE_1__material_dialog__["MDCDialog"](this.$el.querySelector("#canvas-color-edit-dialog"));
    this.deleteConfirmDialog = new __WEBPACK_IMPORTED_MODULE_1__material_dialog__["MDCDialog"](this.$el.querySelector("#canvas-delete-confirm-dialog"));
  },

  methods: {
    onClickOnNav: function onClickOnNav(e) {
      this.$emit("onClickOnNav");
    },
    onItemCreated: function onItemCreated(group, label) {
      this.$emit("onItemCreated", group, label);
    },
    onItemDeleted: function onItemDeleted(group, index) {
      this.$emit("onItemDeleted", group, index);
    },
    onClickOnEditColor: function onClickOnEditColor() {
      this.editColorModel = this.color || '#F56991';
      this.colorDialog.open();
    },
    onClickOnEditTitle: function onClickOnEditTitle() {
      this.editTitleModel = this.name;
      this.dialog.open();
    },
    onClickOnSubmitEditTitle: function onClickOnSubmitEditTitle() {
      this.dialog.close();
      this.$emit("onTitleEdited", this.editTitleModel);
    },
    onClickOnSubmitEditColor: function onClickOnSubmitEditColor() {
      this.colorDialog.close();
      this.$emit("onColorEdited", this.editColorModel);
    },
    onClickOnDeleteCanvas: function onClickOnDeleteCanvas() {
      this.deleteConfirmDialog.open();
    },
    onClickOnConfirmDeleteCanvas: function onClickOnConfirmDeleteCanvas() {
      this.deleteConfirmDialog.close();
      this.$emit("onCanvasDeleted");
    },
    onClickOnHelp: function onClickOnHelp(item) {
      this.$emit("onClickOnHelp", item);
    },
    onClickOnDownloadCanvas: function onClickOnDownloadCanvas() {
      __WEBPACK_IMPORTED_MODULE_3__services_AnalyticsService_js__["a" /* AnalyticsService */].onClickOnExport();
      var canvasClone = document.getElementById("canvas").cloneNode(true);
      canvasClone.querySelectorAll("button").forEach(function (el) {
        return el.remove();
      });
      canvasClone.querySelectorAll(".info-icon").forEach(function (el) {
        return el.style.color = "#fff";
      });
      __WEBPACK_IMPORTED_MODULE_4__services_PdfExportService_js__["a" /* PdfExportService */].exportElement(canvasClone);
    }
  },
  components: {
    CanvasItem: __WEBPACK_IMPORTED_MODULE_0__CanvasItem_vue__["a" /* default */],
    Input: __WEBPACK_IMPORTED_MODULE_2__Input_vue__["a" /* default */]
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CanvasItemInput_vue__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CanvasItemList_vue__ = __webpack_require__(238);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "bmcanvas-list",
  props: ["label", "icon", "items", "buttonBackgroundColor"],
  mounted: function mounted() {},
  data: function data() {
    return {
      isMouseOver: false
    };
  },

  methods: {
    onSubmit: function onSubmit(label) {
      this.$emit('created', label);
    },
    onDelete: function onDelete(index) {
      this.$emit('deleted', index);
    },
    onClickOnHelp: function onClickOnHelp() {
      this.$emit('onClickOnHelp');
    }
  },
  components: {
    CanvasItemInput: __WEBPACK_IMPORTED_MODULE_0__CanvasItemInput_vue__["a" /* default */],
    CanvasItemList: __WEBPACK_IMPORTED_MODULE_1__CanvasItemList_vue__["a" /* default */]
  }
});

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ripple__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ripple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_ripple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_dialog__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Input_vue__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "canvas-item-input",
  props: ['visible', 'buttonBackgroundColor'],
  mounted: function mounted() {
    var fabRipple = new __WEBPACK_IMPORTED_MODULE_0__material_ripple__["MDCRipple"](this.$el.querySelector(".mdc-fab"));
    this.dialog = new __WEBPACK_IMPORTED_MODULE_1__material_dialog__["MDCDialog"](this.$el.querySelector(".mdc-dialog"));
  },
  data: function data() {
    return {
      dialog: null,
      model: ""
    };
  },

  methods: {
    onClickOnSubmit: function onClickOnSubmit() {
      if (!this.model) {
        console.warn("Model must be fulfilled");
        return;
      }
      this.dialog.close();
      this.$emit("submit", this.model);
      this.model = "";
    },
    onClickOnCreate: function onClickOnCreate() {
      this.dialog.open();
    }
  },
  components: {
    Input: __WEBPACK_IMPORTED_MODULE_2__Input_vue__["a" /* default */]
  }
});

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_textfield__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_textfield___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_textfield__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["value", "label", "type"],
  mounted: function mounted() {
    var textField = new __WEBPACK_IMPORTED_MODULE_0__material_textfield__["MDCTextField"](this.$refs.input);
  },

  methods: {
    onChange: function onChange(event) {
      this.$emit("input", event.target.value);
    }
  }
});

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_menu__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_menu__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "bmcanvas-item-list",
  props: ["items"],
  mounted: function mounted() {
    //this.menu = new MDCMenu(this.$el.querySelector(".mdc-menu"));
  },
  data: function data() {
    return {
      menu: null
    };
  },

  methods: {
    onClickOnDelete: function onClickOnDelete(index) {
      this.$emit("onDelete", index);
    }
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnalyticsService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


var AnalyticsService = function () {
    function AnalyticsService() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnalyticsService);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnalyticsService, null, [{
        key: 'onCreateCanvas',
        value: function onCreateCanvas() {
            gtag('event', 'create', { 'event_category': 'Canvas' });
        }
    }, {
        key: 'onRenameCanvas',
        value: function onRenameCanvas() {
            gtag('event', 'rename', { 'event_category': 'Canvas' });
        }
    }, {
        key: 'onDeleteCanvas',
        value: function onDeleteCanvas() {
            gtag('event', 'delete', { 'event_category': 'Canvas' });
        }
    }, {
        key: 'onCreateCanvasItem',
        value: function onCreateCanvasItem() {
            gtag('event', 'create-item', { 'event_category': 'Canvas' });
        }
    }, {
        key: 'onDeleteCanvasItem',
        value: function onDeleteCanvasItem() {
            gtag('event', 'delete-item', { 'event_category': 'Canvas' });
        }
    }, {
        key: 'onLogedIn',
        value: function onLogedIn() {
            gtag('event', 'login', { 'event_category': 'User' });
        }
    }, {
        key: 'onLogedOut',
        value: function onLogedOut() {
            gtag('event', 'logout', { 'event_category': 'User' });
        }
    }, {
        key: 'onSignedUp',
        value: function onSignedUp() {
            gtag('event', 'create', { 'event_category': 'User' });
        }
    }, {
        key: 'onAccountDeleted',
        value: function onAccountDeleted() {
            gtag('event', 'delete', { 'event_category': 'User' });
        }
    }, {
        key: 'onClickOnFeedback',
        value: function onClickOnFeedback() {
            gtag('event', 'click', { 'event_category': 'Feedback' });
        }
    }, {
        key: 'onClickOnExport',
        value: function onClickOnExport() {
            gtag('event', 'export', { 'event_category': 'Canvas' });
        }
    }]);

    return AnalyticsService;
}();

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_vue__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["visible"],
  mounted: function mounted() {
    var _this = this;

    this.dialog = new __WEBPACK_IMPORTED_MODULE_0__material_dialog__["MDCDialog"](this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", function () {
      _this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data: function data() {
    return {
      errored: false,
      dialog: null,
      email: "",
      password: "",
      loading: false,
      isForgotPassword: false,
      passwordResetEmailSuccess: false,
      passwordResetEmailError: false
    };
  },

  methods: {
    onClickOnSubmit: function onClickOnSubmit() {
      var _this2 = this;

      this.loading = true;
      this.$firebase.auth().signInWithEmailAndPassword(this.email, this.password).catch(function (error) {
        _this2.errored = true;
      }).then(function (response) {
        _this2.loading = false;
        if (response && response.user) {
          _this2.errored = false;
          _this2.$emit("onLogedIn", response.user);
        }
      });
    },
    onClickOnSendRecoveryEmail: function onClickOnSendRecoveryEmail() {
      var _this3 = this;

      this.$firebase.auth().sendPasswordResetEmail(this.email).then(function () {
        _this3.passwordResetEmailError = false;
        _this3.passwordResetEmailSuccess = true;
      }).catch(function (error) {
        _this3.passwordResetEmailSuccess = false;
        _this3.passwordResetEmailError = true;
      });
    },
    onClickOnForgotPassword: function onClickOnForgotPassword() {
      this.isForgotPassword = true;
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.errored = false;
        this.isForgotPassword = false;
        this.passwordResetEmailSuccess = false;
        this.passwordResetEmailError = false;
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  components: {
    Input: __WEBPACK_IMPORTED_MODULE_1__Input_vue__["a" /* default */]
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Checkbox_vue__ = __webpack_require__(284);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["visible"],
  mounted: function mounted() {
    var _this = this;

    this.dialog = new __WEBPACK_IMPORTED_MODULE_0__material_dialog__["MDCDialog"](this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", function () {
      _this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data: function data() {
    return {
      errored: false,
      dialog: null,
      email: "",
      password: "",
      accepted: false
    };
  },

  methods: {
    onClickOnSubmit: function onClickOnSubmit() {
      var _this2 = this;

      if (this.canSignUp) {
        this.$firebase.auth().createUserWithEmailAndPassword(this.email, this.password).catch(function (error) {
          console.error(error);
          _this2.errored = true;
        }).then(function (response) {
          if (response) {
            _this2.errored = false;
            _this2.$emit("onSignedUp", response.user);
          }
        });
      }
    }
  },
  computed: {
    canSignUp: function canSignUp() {
      return this.accepted && this.email && this.password;
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.errored = false;
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  components: {
    Input: __WEBPACK_IMPORTED_MODULE_1__Input_vue__["a" /* default */],
    Checkbox: __WEBPACK_IMPORTED_MODULE_2__components_Checkbox_vue__["a" /* default */]
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_form_field__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_form_field___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_form_field__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_checkbox__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__material_checkbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["value", "label"],
  mounted: function mounted() {
    this.checkbox = new __WEBPACK_IMPORTED_MODULE_1__material_checkbox__["MDCCheckbox"](this.$refs.checkbox);
    var formField = new __WEBPACK_IMPORTED_MODULE_0__material_form_field__["MDCFormField"](this.$refs.formField);
    formField.input = this.checkbox;
  },
  data: function data() {
    return {
      checkboxId: __WEBPACK_IMPORTED_MODULE_2_uuid___default.a.v4(),
      checkbox: {}
    };
  },

  methods: {
    onChange: function onChange() {
      this.$emit('input', this.checkbox.checked);
    }
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_AuthService_js__ = __webpack_require__(152);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["visible", "user"],
  mounted: function mounted() {
    var _this = this;

    this.dialog = new __WEBPACK_IMPORTED_MODULE_0__material_dialog__["MDCDialog"](this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", function () {
      _this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data: function data() {
    return {
      errored: false,
      email: ""
    };
  },

  methods: {
    onClickOnDeleteAccount: function onClickOnDeleteAccount() {
      if (this.canDeleteAccount) {
        __WEBPACK_IMPORTED_MODULE_2__services_AuthService_js__["a" /* AuthService */].deleteAccount(this.$firebase);
        this.$emit('onAccountDeleted');
      }
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        this.errored = false;
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  computed: {
    canDeleteAccount: function canDeleteAccount() {
      return this.user && this.user.email === this.email;
    }
  },
  components: {
    Input: __WEBPACK_IMPORTED_MODULE_1__Input_vue__["a" /* default */]
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PersistService__ = __webpack_require__(175);





var AuthService = function () {
    function AuthService() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AuthService);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AuthService, null, [{
        key: 'getUser',
        value: function getUser(fb) {
            if (fb.auth().currentUser) {
                return {
                    email: fb.auth().currentUser.email,
                    uid: fb.auth().currentUser.uid
                };
            } else {
                return null;
            }
        }
    }, {
        key: 'subscribeUser',
        value: function subscribeUser(fb) {
            return new __WEBPACK_IMPORTED_MODULE_2_rxjs__["a" /* Observable */](function (observer) {
                fb.auth().onAuthStateChanged(function (user) {
                    return observer.next(user);
                });
            });
        }
    }, {
        key: 'deleteAccount',
        value: function deleteAccount(fb) {
            __WEBPACK_IMPORTED_MODULE_3__PersistService__["a" /* PersistService */].setModel(fb, []);
            var user = fb.auth().currentUser;
            user.delete();
        }
    }, {
        key: 'signOut',
        value: function signOut(fb) {
            fb.auth().signOut();
        }
    }]);

    return AuthService;
}();

/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PersistService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);






var PersistService = function () {
    function PersistService() {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, PersistService);
    }

    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(PersistService, null, [{
        key: 'setModel',
        value: function setModel(fb, model) {
            localStorage.setItem('model', __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(model));
            if (fb.auth().currentUser) {
                fb.database().ref('users/' + fb.auth().currentUser.uid).set(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(model));
            }
        }
    }, {
        key: 'getModel',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fb) {
                var model, parsedModel;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                model = void 0;
                                parsedModel = void 0;

                                if (!fb.auth().currentUser) {
                                    _context.next = 8;
                                    break;
                                }

                                _context.next = 5;
                                return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (res, rej) {
                                    fb.database().ref('users/' + fb.auth().currentUser.uid).once('value', function (value) {
                                        res(value.val());
                                    });
                                });

                            case 5:
                                model = _context.sent;
                                _context.next = 9;
                                break;

                            case 8:
                                model = localStorage.getItem('model');

                            case 9:
                                try {
                                    parsedModel = JSON.parse(model);
                                } catch (e) {
                                    console.error(e);
                                }

                                if (!parsedModel) {
                                    _context.next = 14;
                                    break;
                                }

                                return _context.abrupt('return', parsedModel);

                            case 14:
                                return _context.abrupt('return', []);

                            case 15:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function getModel(_x) {
                return _ref.apply(this, arguments);
            }

            return getModel;
        }()
    }]);

    return PersistService;
}();

/***/ }),
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_vue__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["visible"],
  mounted: function mounted() {
    var _this = this;

    this.dialog = new __WEBPACK_IMPORTED_MODULE_0__material_dialog__["MDCDialog"](this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", function () {
      _this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data: function data() {
    return {
      dialog: null
    };
  },

  watch: {
    visible: function visible(val) {
      if (val) {
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  components: {
    Input: __WEBPACK_IMPORTED_MODULE_1__Input_vue__["a" /* default */]
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_vue__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["visible"],
  mounted: function mounted() {
    var _this = this;

    this.dialog = new __WEBPACK_IMPORTED_MODULE_0__material_dialog__["MDCDialog"](this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", function () {
      _this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data: function data() {
    return {
      dialog: null
    };
  },

  watch: {
    visible: function visible(val) {
      if (val) {
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  components: {
    Input: __WEBPACK_IMPORTED_MODULE_1__Input_vue__["a" /* default */]
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_vue__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["visible"],
  mounted: function mounted() {
    var _this = this;

    this.dialog = new __WEBPACK_IMPORTED_MODULE_0__material_dialog__["MDCDialog"](this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", function () {
      _this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data: function data() {
    return {
      dialog: null
    };
  },

  watch: {
    visible: function visible(val) {
      if (val) {
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  components: {
    Input: __WEBPACK_IMPORTED_MODULE_1__Input_vue__["a" /* default */]
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_vue__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["visible"],
  mounted: function mounted() {
    var _this = this;

    this.dialog = new __WEBPACK_IMPORTED_MODULE_0__material_dialog__["MDCDialog"](this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", function () {
      _this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data: function data() {
    return {
      dialog: null
    };
  },

  watch: {
    visible: function visible(val) {
      if (val) {
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  components: {
    Input: __WEBPACK_IMPORTED_MODULE_1__Input_vue__["a" /* default */]
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_vue__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["visible"],
  mounted: function mounted() {
    var _this = this;

    this.dialog = new __WEBPACK_IMPORTED_MODULE_0__material_dialog__["MDCDialog"](this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", function () {
      _this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data: function data() {
    return {
      dialog: null
    };
  },

  watch: {
    visible: function visible(val) {
      if (val) {
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  components: {
    Input: __WEBPACK_IMPORTED_MODULE_1__Input_vue__["a" /* default */]
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_vue__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["visible"],
  mounted: function mounted() {
    var _this = this;

    this.dialog = new __WEBPACK_IMPORTED_MODULE_0__material_dialog__["MDCDialog"](this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", function () {
      _this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data: function data() {
    return {
      dialog: null
    };
  },

  watch: {
    visible: function visible(val) {
      if (val) {
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  components: {
    Input: __WEBPACK_IMPORTED_MODULE_1__Input_vue__["a" /* default */]
  }
});

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_vue__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["visible"],
  mounted: function mounted() {
    var _this = this;

    this.dialog = new __WEBPACK_IMPORTED_MODULE_0__material_dialog__["MDCDialog"](this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", function () {
      _this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data: function data() {
    return {
      dialog: null
    };
  },

  watch: {
    visible: function visible(val) {
      if (val) {
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  components: {
    Input: __WEBPACK_IMPORTED_MODULE_1__Input_vue__["a" /* default */]
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_vue__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["visible"],
  mounted: function mounted() {
    var _this = this;

    this.dialog = new __WEBPACK_IMPORTED_MODULE_0__material_dialog__["MDCDialog"](this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", function () {
      _this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data: function data() {
    return {
      dialog: null
    };
  },

  watch: {
    visible: function visible(val) {
      if (val) {
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  components: {
    Input: __WEBPACK_IMPORTED_MODULE_1__Input_vue__["a" /* default */]
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__material_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input_vue__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["visible"],
  mounted: function mounted() {
    var _this = this;

    this.dialog = new __WEBPACK_IMPORTED_MODULE_0__material_dialog__["MDCDialog"](this.$refs.dialog);
    this.dialog.listen("MDCDialog:closed", function () {
      _this.$emit("onClosed");
    });
    this.visible && this.dialog.open();
  },
  data: function data() {
    return {
      dialog: null
    };
  },

  watch: {
    visible: function visible(val) {
      if (val) {
        this.dialog.open();
      } else {
        this.dialog.close();
      }
    }
  },
  components: {
    Input: __WEBPACK_IMPORTED_MODULE_1__Input_vue__["a" /* default */]
  }
});

/***/ }),
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_auth__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_database__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_fab_dist_mdc_fab_css__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_fab_dist_mdc_fab_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_fab_dist_mdc_fab_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_textfield_dist_mdc_textfield_css__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_textfield_dist_mdc_textfield_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_textfield_dist_mdc_textfield_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_dialog_dist_mdc_dialog_css__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_dialog_dist_mdc_dialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_dialog_dist_mdc_dialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_button_dist_mdc_button_css__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_button_dist_mdc_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_button_dist_mdc_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_drawer_dist_mdc_drawer_css__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_drawer_dist_mdc_drawer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_drawer_dist_mdc_drawer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_list_dist_mdc_list_css__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_list_dist_mdc_list_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_list_dist_mdc_list_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_icon_button_dist_mdc_icon_button_css__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_icon_button_dist_mdc_icon_button_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_icon_button_dist_mdc_icon_button_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_form_field_dist_mdc_form_field_css__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_form_field_dist_mdc_form_field_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_form_field_dist_mdc_form_field_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_checkbox_dist_mdc_checkbox_css__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_checkbox_dist_mdc_checkbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_checkbox_dist_mdc_checkbox_css__);






//import "firebase/firestore";
//import "firebase/messaging";
//import "firebase/functions";











// Firebase App is always required and must be first

// Add additional services that you want to use

// Comment out (or don't require) services that you don't want to use
// require("firebase/storage");

var config = {
  apiKey: "AIzaSyCIW2GchrE3r5Gyv9l0z6-rSiX3izhISio",
  authDomain: "mbc-tool.firebaseapp.com",
  databaseURL: "https://mbc-tool.firebaseio.com",
  projectId: "mbc-tool",
  storageBucket: "mbc-tool.appspot.com",
  messagingSenderId: "722372598798"
};
var firebaseApp = __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.initializeApp(config);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$firebase = firebaseApp;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),
/* 200 */,
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(112);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f79f2a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(391);
function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08f79f2a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CanvasItem_vue__ = __webpack_require__(131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476c654e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CanvasItem_vue__ = __webpack_require__(242);
function injectStyle (ssrContext) {
  __webpack_require__(230)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-476c654e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CanvasItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476c654e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CanvasItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CanvasItemInput_vue__ = __webpack_require__(132);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9a1da1c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CanvasItemInput_vue__ = __webpack_require__(237);
function injectStyle (ssrContext) {
  __webpack_require__(232)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f9a1da1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CanvasItemInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9a1da1c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CanvasItemInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 232 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 233 */,
/* 234 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 235 */,
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"input",staticClass:"mdc-text-field mdc-text-field--outlined"},[_c('input',{staticClass:"mdc-text-field__input",attrs:{"type":this.type || 'text'},domProps:{"value":_vm.value},on:{"change":_vm.onChange}}),_vm._v(" "),_c('div',{staticClass:"mdc-notched-outline"},[_c('div',{staticClass:"mdc-notched-outline__leading"}),_vm._v(" "),_c('div',{staticClass:"mdc-notched-outline__notch"},[_c('label',{staticClass:"mdc-floating-label",attrs:{"for":"tf-outlined"}},[_vm._v(_vm._s(_vm.label))])]),_vm._v(" "),_c('div',{staticClass:"mdc-notched-outline__trailing"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"bmc-canvas__item-input",on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onClickOnSubmit()}}},[_c('button',{staticClass:"hide-print mdc-fab mdc-fab--mini",style:({'background-color': _vm.buttonBackgroundColor}),attrs:{"aria-label":"Favorite"},on:{"click":function($event){_vm.onClickOnCreate()}}},[_c('span',{staticClass:"mdc-fab__icon material-icons"},[_vm._v("add")])]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog",attrs:{"role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"}},[_c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_vm._v("Create item")]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[_c('Input',{attrs:{"label":"Description"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"mdc-button mdc-button--raised mdc-dialog__button",attrs:{"type":"button"},on:{"click":function($event){_vm.onClickOnSubmit()}}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Create")])])])])]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CanvasItemList_vue__ = __webpack_require__(134);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd51498_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CanvasItemList_vue__ = __webpack_require__(241);
function injectStyle (ssrContext) {
  __webpack_require__(239)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CanvasItemList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bd51498_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CanvasItemList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */,
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.items),function(item,idx){return _c('li',{key:item.id},[_c('span',{staticClass:"canvas-item-list__item-label",on:{"click":function($event){_vm.onClickOnDelete(idx)}}},[_vm._v("\n        "+_vm._s(item.label)+"\n        "),_c('i',{staticClass:"material-icons"},[_vm._v("delete_outline")])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item h-100"},[_c('div',{staticClass:"header"},[_c('i',{staticClass:"material-icons main-icon"},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('i',{staticClass:"material-icons info-icon hide-print",on:{"click":function($event){_vm.onClickOnHelp()}}},[_vm._v("help_outline")]),_vm._v(" "),_c('p',{staticClass:"only-print"})]),_vm._v(" "),_c('div',{staticClass:"list"},[_c('CanvasItemList',{attrs:{"items":_vm.items},on:{"onDelete":_vm.onDelete}})],1),_vm._v(" "),_c('CanvasItemInput',{attrs:{"buttonBackgroundColor":_vm.buttonBackgroundColor,"visible":true},on:{"submit":_vm.onSubmit}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PdfExportService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jspdf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jspdf__);





var PdfExportService = function () {
    function PdfExportService() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PdfExportService);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(PdfExportService, null, [{
        key: 'exportElement',
        value: function exportElement(element) {
            element.style.width = "1754px";
            element.style.height = "1240px";
            document.body.append(element);
            __WEBPACK_IMPORTED_MODULE_2_html2canvas___default()(element, { useCORS: true, logging: false }).then(function (image) {
                document.body.removeChild(element);
                var doc = new __WEBPACK_IMPORTED_MODULE_3_jspdf___default.a('landscape', '', 'a4', true);
                var docWidth = doc.internal.pageSize.getWidth();
                var docHeight = doc.internal.pageSize.getHeight();
                doc.addImage(image.toDataURL('image/png'), 'PNG', 0, 0, docWidth, docHeight, '', 'FAST');
                doc.save('canvas.pdf');
            });
        }
    }]);

    return PdfExportService;
}();

/***/ }),
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-100",attrs:{"id":"canvas"}},[_c('div',{staticClass:"bmc-toolbar",style:({'background-color': _vm.color || '#F56991'}),on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"bmc-toolbar__title"},[_c('button',{staticClass:"hide-print mdc-icon-button material-icons",on:{"click":function($event){_vm.onClickOnNav()}}},[_vm._v("menu")]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.name))])]),_vm._v(" "),_c('div',{staticClass:"bmc-toolbar__buttons hide-print"},[_c('button',{staticClass:"hide-print mdc-icon-button material-icons",on:{"click":function($event){_vm.onClickOnEditColor()}}},[_vm._v("color_lens")]),_vm._v(" "),_c('button',{staticClass:"hide-print mdc-icon-button material-icons",on:{"click":function($event){_vm.onClickOnEditTitle()}}},[_vm._v("edit")]),_vm._v(" "),_c('button',{staticClass:"mdc-icon-button material-icons",on:{"click":function($event){_vm.onClickOnDownloadCanvas()}}},[_vm._v("cloud_download")]),_vm._v(" "),_c('button',{staticClass:"mdc-icon-button material-icons",on:{"click":function($event){_vm.onClickOnDeleteCanvas()}}},[_vm._v("delete")])])]),_vm._v(" "),_c('div',{staticClass:"bmc-canvas"},[_c('div',{staticClass:"bmc-canvas__top"},[_c('div',{staticClass:"bmc-canvas__item bmc-canvas__partnership"},[_c('CanvasItem',{attrs:{"buttonBackgroundColor":_vm.color,"items":_vm.items['key-partners'],"label":"Key partners","icon":"all_inclusive"},on:{"onClickOnHelp":function($event){_vm.onClickOnHelp('key-partners')},"created":function (label) { return _vm.onItemCreated('key-partners', label); },"deleted":function (index) { return _vm.onItemDeleted('key-partners', index); }}})],1),_vm._v(" "),_c('div',{staticClass:"bmc-canvas__item bmc-canvas__activities"},[_c('CanvasItem',{attrs:{"buttonBackgroundColor":_vm.color,"items":_vm.items['key-activities'],"label":"Key activities","icon":"golf_course"},on:{"onClickOnHelp":function($event){_vm.onClickOnHelp('key-activities')},"created":function (label) { return _vm.onItemCreated('key-activities', label); },"deleted":function (index) { return _vm.onItemDeleted('key-activities', index); }}})],1),_vm._v(" "),_c('div',{staticClass:"bmc-canvas__item bmc-canvas__resources"},[_c('CanvasItem',{attrs:{"buttonBackgroundColor":_vm.color,"items":_vm.items['key-resources'],"label":"Key resources","icon":"location_city"},on:{"onClickOnHelp":function($event){_vm.onClickOnHelp('key-resources')},"created":function (label) { return _vm.onItemCreated('key-resources', label); },"deleted":function (index) { return _vm.onItemDeleted('key-resources', index); }}})],1),_vm._v(" "),_c('div',{staticClass:"bmc-canvas__item bmc-canvas__value"},[_c('CanvasItem',{attrs:{"buttonBackgroundColor":_vm.color,"items":_vm.items['value-propositions'],"label":"Value propositions","icon":"cake"},on:{"onClickOnHelp":function($event){_vm.onClickOnHelp('value-propositions')},"created":function (label) { return _vm.onItemCreated('value-propositions', label); },"deleted":function (index) { return _vm.onItemDeleted('value-propositions', index); }}})],1),_vm._v(" "),_c('div',{staticClass:"bmc-canvas__item bmc-canvas__customer-relations"},[_c('CanvasItem',{attrs:{"buttonBackgroundColor":_vm.color,"items":_vm.items['customer-relationships'],"label":"Customer relationships","icon":"group"},on:{"onClickOnHelp":function($event){_vm.onClickOnHelp('customer-relationships')},"created":function (label) { return _vm.onItemCreated('customer-relationships', label); },"deleted":function (index) { return _vm.onItemDeleted('customer-relationships', index); }}})],1),_vm._v(" "),_c('div',{staticClass:"bmc-canvas__item bmc-canvas__channels"},[_c('CanvasItem',{attrs:{"buttonBackgroundColor":_vm.color,"items":_vm.items['channels'],"label":"Channels","icon":"wifi_tethering"},on:{"onClickOnHelp":function($event){_vm.onClickOnHelp('channels')},"created":function (label) { return _vm.onItemCreated('channels', label); },"deleted":function (index) { return _vm.onItemDeleted('channels', index); }}})],1),_vm._v(" "),_c('div',{staticClass:"bmc-canvas__item bmc-canvas__customer-segments"},[_c('CanvasItem',{attrs:{"buttonBackgroundColor":_vm.color,"items":_vm.items['customer-segments'],"label":"Customer segments","icon":"list_alt"},on:{"onClickOnHelp":function($event){_vm.onClickOnHelp('customer-segments')},"created":function (label) { return _vm.onItemCreated('customer-segments', label); },"deleted":function (index) { return _vm.onItemDeleted('customer-segments', index); }}})],1)]),_vm._v(" "),_c('div',{staticClass:"bmc-canvas__bottom"},[_c('div',{staticClass:"bmc-canvas__item bmc-canvas__costs"},[_c('CanvasItem',{attrs:{"buttonBackgroundColor":_vm.color,"items":_vm.items['cost-structure'],"label":"Cost structure","icon":"money_off"},on:{"onClickOnHelp":function($event){_vm.onClickOnHelp('cost-structure')},"created":function (label) { return _vm.onItemCreated('cost-structure', label); },"deleted":function (index) { return _vm.onItemDeleted('cost-structure', index); }}})],1),_vm._v(" "),_c('div',{staticClass:"bmc-canvas__item bmc-canvas__incomes"},[_c('CanvasItem',{attrs:{"buttonBackgroundColor":_vm.color,"items":_vm.items['revenue-streams'],"label":"Revenue streams","icon":"attach_money"},on:{"onClickOnHelp":function($event){_vm.onClickOnHelp('revenue-streams')},"created":function (label) { return _vm.onItemCreated('revenue-streams', label); },"deleted":function (index) { return _vm.onItemDeleted('revenue-streams', index); }}})],1)])]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog",attrs:{"id":"canvas-title-edit-dialog","role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"},on:{"click":function($event){$event.stopPropagation();},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onClickOnSubmitEditTitle()}}},[_c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_vm._v("Edit title")]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[_c('Input',{attrs:{"label":"Title"},model:{value:(_vm.editTitleModel),callback:function ($$v) {_vm.editTitleModel=$$v},expression:"editTitleModel"}})],1),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"mdc-button mdc-button--raised mdc-dialog__button",attrs:{"type":"button"},on:{"click":function($event){_vm.onClickOnSubmitEditTitle()}}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Save")])])])])]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog",attrs:{"id":"canvas-color-edit-dialog","role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"},on:{"click":function($event){$event.stopPropagation();},"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onClickOnSubmitEditColor()}}},[_c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_vm._v("Edit color")]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[_vm._m(1),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.editColorModel),expression:"editColorModel"}],attrs:{"type":"color"},domProps:{"value":(_vm.editColorModel)},on:{"input":function($event){if($event.target.composing){ return; }_vm.editColorModel=$event.target.value}}})]),_vm._v(" "),_c('Input',{attrs:{"label":"Color"},model:{value:(_vm.editColorModel),callback:function ($$v) {_vm.editColorModel=$$v},expression:"editColorModel"}})],1),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_vm._m(2),_vm._v(" "),_c('button',{staticClass:"mdc-button mdc-button--raised mdc-dialog__button",attrs:{"type":"button"},on:{"click":function($event){_vm.onClickOnSubmitEditColor()}}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Save")])])])])]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog",attrs:{"id":"canvas-delete-confirm-dialog","role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"},on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_vm._v("Are you sure?")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_vm._m(4),_vm._v(" "),_c('button',{staticClass:"mdc-button mdc-button--raised mdc-dialog__button",attrs:{"type":"button"},on:{"click":function($event){_vm.onClickOnConfirmDeleteCanvas()}}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Delete")])])])])]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n            Use the color picker or insert\n            "),_c('br'),_vm._v("the HEX code below\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[_c('p',[_vm._v("Are you sure you want to delete the canvas?")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginDialog_vue__ = __webpack_require__(148);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6de155ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginDialog_vue__ = __webpack_require__(281);
function injectStyle (ssrContext) {
  __webpack_require__(280)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6de155ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6de155ea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 280 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dialog",staticClass:"mdc-dialog",attrs:{"role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onClickOnSubmit()}}},[_c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[(!_vm.isForgotPassword)?_c('h2',{staticClass:"mdc-dialog__title"},[_vm._v("Log in")]):_vm._e(),_vm._v(" "),(_vm.isForgotPassword)?_c('h2',{staticClass:"mdc-dialog__title"},[_vm._v("Recover your password")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[(_vm.errored)?_c('p',{staticClass:"text-error"},[_vm._v("There was an error. Check your email and password are valid or try again later")]):_vm._e(),_vm._v(" "),(_vm.passwordResetEmailSuccess)?_c('p',{staticClass:"text-success"},[_vm._v("A reset password email has been sent")]):_vm._e(),_vm._v(" "),(_vm.passwordResetEmailError)?_c('p',{staticClass:"text-error"},[_vm._v("Couldn't send reset password email. Ensure the email exists or try again later")]):_vm._e(),_vm._v(" "),_c('Input',{attrs:{"label":"Email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('div',{staticClass:"separator"}),_vm._v(" "),(!_vm.isForgotPassword)?_c('Input',{attrs:{"label":"Password","type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"separator"}),_vm._v(" "),(!_vm.isForgotPassword)?_c('a',{on:{"click":function($event){_vm.onClickOnForgotPassword()}}},[_vm._v("Forgot your password?")]):_vm._e()],1),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_vm._m(0),_vm._v(" "),(!_vm.isForgotPassword)?_c('button',{staticClass:"mdc-button mdc-button--raised mdc-dialog__button",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){_vm.onClickOnSubmit()}}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Log in")])]):_vm._e(),_vm._v(" "),(_vm.isForgotPassword)?_c('button',{staticClass:"mdc-button mdc-button--raised mdc-dialog__button",attrs:{"type":"button","disabled":_vm.loading},on:{"click":function($event){_vm.onClickOnSendRecoveryEmail()}}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Recover")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUpDialog_vue__ = __webpack_require__(149);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c1e58ef_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpDialog_vue__ = __webpack_require__(289);
function injectStyle (ssrContext) {
  __webpack_require__(283)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c1e58ef"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUpDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c1e58ef_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUpDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__(150);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b006546_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__(288);
function injectStyle (ssrContext) {
  __webpack_require__(285)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b006546"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b006546_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */,
/* 287 */,
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"formField",staticClass:"mdc-form-field"},[_c('div',{ref:"checkbox",staticClass:"mdc-checkbox"},[_c('input',{staticClass:"mdc-checkbox__native-control",attrs:{"type":"checkbox","id":_vm.checkboxId},domProps:{"value":_vm.value},on:{"input":_vm.onChange}}),_vm._v(" "),_c('div',{staticClass:"mdc-checkbox__background"},[_c('svg',{staticClass:"mdc-checkbox__checkmark",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{staticClass:"mdc-checkbox__checkmark-path",attrs:{"fill":"none","d":"M1.73,12.91 8.1,19.28 22.79,4.59"}})]),_vm._v(" "),_c('div',{staticClass:"mdc-checkbox__mixedmark"})])]),_vm._v(" "),_c('label',{attrs:{"for":_vm.checkboxId},domProps:{"innerHTML":_vm._s(_vm.label)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dialog",staticClass:"mdc-dialog",attrs:{"role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onClickOnSubmit()}}},[_c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_vm._v("Sign up")]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[(_vm.errored)?_c('p',{staticClass:"text-error"},[_vm._v("There was an error. Check your email and password are valid or try again later")]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("If you have local changes, they will be kept in your new account")]),_vm._v(" "),_c('Input',{attrs:{"label":"Email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('div',{staticClass:"separator"}),_vm._v(" "),_c('Input',{attrs:{"label":"Password","type":"password"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('div',{staticClass:"separator"}),_vm._v(" "),_c('Checkbox',{attrs:{"label":"I have read and accept the <a href='https://docs.google.com/document/d/1Ws9BShodxPo8ZH-5uG2EqM4FljZcaK9Q9l5EJtHbFbk/edit?usp=sharing' target='_blank'>Privacy policy</a>"},model:{value:(_vm.accepted),callback:function ($$v) {_vm.accepted=$$v},expression:"accepted"}})],1),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"mdc-button mdc-button--raised mdc-dialog__button",attrs:{"disabled":!_vm.canSignUp,"type":"button"},on:{"click":function($event){_vm.onClickOnSubmit()}}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Sign up")])])])])]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserSettingsDialog_vue__ = __webpack_require__(151);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eb90d3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserSettingsDialog_vue__ = __webpack_require__(363);
function injectStyle (ssrContext) {
  __webpack_require__(291)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0eb90d3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserSettingsDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0eb90d3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserSettingsDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dialog",staticClass:"mdc-dialog",attrs:{"role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"}},[_c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_vm._v("User settings")]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[_c('h4',[_vm._v("Delete account")]),_vm._v(" "),_c('p',[_vm._v("Type your email and press the button to permanently delete your account and personal data")]),_vm._v(" "),_c('Input',{attrs:{"label":"Email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('div'),_vm._v(" "),_c('button',{class:{'mdc-button mdc-button--raised mdc-button--error': true, 'mdc-button--disabled': !_vm.canDeleteAccount},on:{"click":function($event){_vm.onClickOnDeleteAccount()}}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Delete account")])])],1),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"mdc-dialog__actions"},[_c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyPartnersHelpDialog_vue__ = __webpack_require__(180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b820451_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyPartnersHelpDialog_vue__ = __webpack_require__(366);
function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7b820451"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyPartnersHelpDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b820451_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyPartnersHelpDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dialog",staticClass:"mdc-dialog",attrs:{"role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onClickOnSubmit()}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_c('i',{staticClass:"material-icons"},[_vm._v("all_inclusive")]),_vm._v(" Key partners\n      ")]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[_c('p',[_vm._v("In order to optimize operations and reduce risks of a business model, organizations usually cultivate buyer-supplier relationships so they can focus on their core activity.")]),_vm._v(" "),_c('p',[_vm._v("Complementary business alliances also can be considered through joint ventures or strategic alliances between competitors or non-competitors.")])]),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyResourcesHelpDialog_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a46729ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyResourcesHelpDialog_vue__ = __webpack_require__(369);
function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a46729ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyResourcesHelpDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a46729ca_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyResourcesHelpDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dialog",staticClass:"mdc-dialog",attrs:{"role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onClickOnSubmit()}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_c('i',{staticClass:"material-icons"},[_vm._v("location_city")]),_vm._v(" Key resources\n      ")]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[_c('p',[_vm._v("The resources that are necessary to create value for the customer.")]),_vm._v(" "),_c('p',[_vm._v("They are considered assets to a company that are needed to sustain and support the business. These resources could be human, financial, physical and intellectual.")])]),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyActivitiesHelpDialog_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b01c92b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyActivitiesHelpDialog_vue__ = __webpack_require__(372);
function injectStyle (ssrContext) {
  __webpack_require__(371)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4b01c92b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KeyActivitiesHelpDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b01c92b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_KeyActivitiesHelpDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dialog",staticClass:"mdc-dialog",attrs:{"role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onClickOnSubmit()}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_c('i',{staticClass:"material-icons"},[_vm._v("golf_course")]),_vm._v(" Key activities\n      ")]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[_c('p',[_vm._v("The most important activities in executing a company's value proposition.")]),_vm._v(" "),_c('p',[_vm._v("An example for Bic, the pen manufacturer, would be creating an efficient supply chain to drive down costs.")])]),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValuePropositionsHelpDialog_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4afbe61a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValuePropositionsHelpDialog_vue__ = __webpack_require__(375);
function injectStyle (ssrContext) {
  __webpack_require__(374)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4afbe61a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ValuePropositionsHelpDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4afbe61a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ValuePropositionsHelpDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dialog",staticClass:"mdc-dialog",attrs:{"role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onClickOnSubmit()}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_c('i',{staticClass:"material-icons"},[_vm._v("cake")]),_vm._v(" Value propositions\n      ")]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[_c('p',[_vm._v("The collection of products and services a business offers to meet the needs of its customers.")]),_vm._v(" "),_c('p',[_vm._v("According to Osterwalder (2004), a company's value proposition is what distinguishes it from its competitors. The value proposition provides value through various elements such as newness, performance, customization, \"getting the job done\", design, brand/status, price, cost reduction, risk reduction, accessibility, and convenience/usability.")]),_vm._v(" "),_c('p',[_vm._v("The value propositions may be Quantitative (price and efficiency) or Qualitative (overall customer experience and outcome)")])]),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerRelationshipsHelpDialog_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37ed0e60_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerRelationshipsHelpDialog_vue__ = __webpack_require__(378);
function injectStyle (ssrContext) {
  __webpack_require__(377)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-37ed0e60"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerRelationshipsHelpDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37ed0e60_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerRelationshipsHelpDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dialog",staticClass:"mdc-dialog",attrs:{"role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onClickOnSubmit()}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_c('i',{staticClass:"material-icons"},[_vm._v("group")]),_vm._v(" Customer relationships\n      ")]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[_c('p',[_vm._v("To ensure the survival and success of any businesses, companies must identify the type of relationship they want to create with their customer segments.")]),_vm._v(" "),_c('p',[_vm._v("Various forms of customer relationships include: Personal Assistance, Dedicated Personal Assistance, Self Service, Automated Services, Communities or Co-creation")])]),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelsHelpDialog_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55eff7fb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChannelsHelpDialog_vue__ = __webpack_require__(381);
function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55eff7fb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ChannelsHelpDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55eff7fb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ChannelsHelpDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dialog",staticClass:"mdc-dialog",attrs:{"role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onClickOnSubmit()}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_c('i',{staticClass:"material-icons"},[_vm._v("wifi_tethering")]),_vm._v(" Channels\n      ")]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[_c('p',[_vm._v("A company can deliver its value proposition to its targeted customers through different channels.")]),_vm._v(" "),_c('p',[_vm._v("Effective channels will distribute a company’s value proposition in ways that are fast, efficient and cost-effective. An organization can reach its clients through its own channels (store front), partner channels (major distributors), or a combination of both.")])]),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerSegmentsHelpDialog_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410d6004_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerSegmentsHelpDialog_vue__ = __webpack_require__(384);
function injectStyle (ssrContext) {
  __webpack_require__(383)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-410d6004"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerSegmentsHelpDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_410d6004_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerSegmentsHelpDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 383 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dialog",staticClass:"mdc-dialog",attrs:{"role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onClickOnSubmit()}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_c('i',{staticClass:"material-icons"},[_vm._v("list_alt")]),_vm._v(" Customer segments\n      ")]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[_c('p',[_vm._v("To build an effective business model, a company must identify which customers it tries to serve.")]),_vm._v(" "),_c('p',[_vm._v("Various sets of customers can be segmented based on their different needs and attributes to ensure appropriate implementation of corporate strategy to meet the characteristics of selected groups of clients.")])]),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CostStructureHelpDialog_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cbc6fbe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CostStructureHelpDialog_vue__ = __webpack_require__(387);
function injectStyle (ssrContext) {
  __webpack_require__(386)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cbc6fbe"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CostStructureHelpDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cbc6fbe_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CostStructureHelpDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 386 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dialog",staticClass:"mdc-dialog",attrs:{"role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onClickOnSubmit()}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_c('i',{staticClass:"material-icons"},[_vm._v("money_off")]),_vm._v(" Cost structure\n      ")]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[_c('p',[_vm._v("This describes the most important monetary consequences while operating under different business models.")])]),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RevenueStreamsHelpDialog_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a3b3d9a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RevenueStreamsHelpDialog_vue__ = __webpack_require__(390);
function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2a3b3d9a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RevenueStreamsHelpDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a3b3d9a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RevenueStreamsHelpDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dialog",staticClass:"mdc-dialog",attrs:{"role":"alertdialog","aria-modal":"true","aria-labelledby":"my-dialog-title","aria-describedby":"my-dialog-content"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.onClickOnSubmit()}}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__scrim"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdc-dialog__container"},[_c('div',{staticClass:"mdc-dialog__surface"},[_c('h2',{staticClass:"mdc-dialog__title",attrs:{"id":"my-dialog-title"}},[_c('i',{staticClass:"material-icons"},[_vm._v("attach_money")]),_vm._v(" Revenue streams\n      ")]),_vm._v(" "),_c('div',{staticClass:"mdc-dialog__content",attrs:{"id":"my-dialog-content"}},[_c('p',[_vm._v("The way a company makes income from each customer segment.")]),_vm._v(" "),_c('p',[_vm._v("Some examples include: Asset sale, Usage fee or Subscription fees")])]),_vm._v(" "),_c('footer',{staticClass:"mdc-dialog__actions"},[_c('button',{staticClass:"mdc-button mdc-dialog__button",attrs:{"type":"button","data-mdc-dialog-action":"close"}},[_c('span',{staticClass:"mdc-button__label"},[_vm._v("Cancel")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('aside',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAsideVisible),expression:"isAsideVisible"}],staticClass:"mdc-drawer"},[_c('div',{staticClass:"mdc-drawer__header"},[_c('img',{staticClass:"logo",attrs:{"alt":"Business Model Canvas Tool","src":"/static/logo-bmc-white.png"}}),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("Made with ❤️ by hola@albertvazquez.es")]),_vm._v(" "),_c('p',{staticClass:"small"},[_vm._v("\n        💡 Would you improve it?\n        "),_c('a',{attrs:{"target":"_blank","href":"https://docs.google.com/forms/d/e/1FAIpQLSefqCzE18BPMSK_UUn7bEeoh2OOeDDhbxko6q5wHXDORdmWtw/viewform"},on:{"click":function($event){_vm.onClickOnFeedback()}}},[_vm._v("Leave feedback")])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('hr',{staticClass:"mdc-list-divider"}),_vm._v(" "),_c('div',{staticClass:"mdc-drawer__content"},[_c('nav',{staticClass:"mdc-list"},[(this.user && this.user.uid)?_c('a',{staticClass:"mdc-list-item",attrs:{"href":"#","aria-selected":"true"},on:{"click":function($event){_vm.onClickOnUserSettings()}}},[_c('i',{staticClass:"material-icons mdc-list-item__graphic",attrs:{"aria-hidden":"true"}},[_vm._v("settings")]),_vm._v(" "),_c('span',{staticClass:"mdc-list-item__text"},[_vm._v(_vm._s(this.user.email))])]):_vm._e(),_vm._v(" "),(!this.user || !this.user.uid)?_c('a',{staticClass:"mdc-list-item",attrs:{"href":"#","aria-selected":"true"},on:{"click":function($event){_vm.onClickOnLogIn()}}},[_c('i',{staticClass:"material-icons mdc-list-item__graphic",attrs:{"aria-hidden":"true"}},[_vm._v("perm_identity")]),_vm._v(" "),_c('span',{staticClass:"mdc-list-item__text"},[_vm._v("Log in")])]):_vm._e(),_vm._v(" "),(!this.user || !this.user.uid)?_c('a',{staticClass:"mdc-list-item",attrs:{"href":"#","aria-selected":"true"},on:{"click":function($event){_vm.onClickOnSignUp()}}},[_c('i',{staticClass:"material-icons mdc-list-item__graphic",attrs:{"aria-hidden":"true"}},[_vm._v("person_add")]),_vm._v(" "),_c('span',{staticClass:"mdc-list-item__text"},[_vm._v("Sign up")])]):_vm._e(),_vm._v(" "),(this.user && this.user.uid)?_c('a',{staticClass:"mdc-list-item",attrs:{"href":"#","aria-selected":"true"},on:{"click":function($event){_vm.onClickOnSignOut()}}},[_c('i',{staticClass:"material-icons mdc-list-item__graphic",attrs:{"aria-hidden":"true"}},[_vm._v("exit_to_app")]),_vm._v(" "),_c('span',{staticClass:"mdc-list-item__text"},[_vm._v("Sign out")])]):_vm._e(),_vm._v(" "),_c('hr',{staticClass:"mdc-list-divider"}),_vm._v(" "),_c('h6',{staticClass:"mdc-list-group__subheader"},[_vm._v("Canvas")]),_vm._v(" "),_c('a',{staticClass:"mdc-list-item",attrs:{"href":"#","aria-selected":"true"},on:{"click":function($event){_vm.onClickOnAddCanvas()}}},[_c('i',{staticClass:"material-icons mdc-list-item__graphic",attrs:{"aria-hidden":"true"}},[_vm._v("add")]),_vm._v(" "),_c('span',{staticClass:"mdc-list-item__text"},[_vm._v("Create")])]),_vm._v(" "),_c('hr',{staticClass:"mdc-list-divider"}),_vm._v(" "),_vm._l((_vm.canvas),function(c,idx){return _c('a',{key:c.id,staticClass:"mdc-list-item",class:{'mdc-list-item--activated': _vm.selectedCanvasIdx === idx},on:{"click":function($event){_vm.onClickOnCanvas(idx)}}},[_c('i',{staticClass:"material-icons mdc-list-item__graphic",attrs:{"aria-hidden":"true"}},[_vm._v("view_module")]),_vm._v(" "),_c('span',{staticClass:"mdc-list-item__text"},[_vm._v(_vm._s(c.name))])])})],2)]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"main",on:{"click":_vm.onClickOnCanvasComponent}},[(_vm.selectedCanvas && _vm.selectedCanvas.id)?_c('Canvas',{attrs:{"color":_vm.selectedCanvas.color,"name":_vm.selectedCanvas.name,"items":_vm.selectedCanvas.items,"id":_vm.selectedCanvas.id},on:{"onClickOnNav":_vm.onClickOnNav,"onClickOnHelp":_vm.onClickOnHelp,"onCanvasDeleted":function($event){_vm.onCanvasDeleted()},"onTitleEdited":_vm.onCanvasTitleEdited,"onItemCreated":_vm.onItemCreated,"onItemDeleted":_vm.onItemDeleted,"onColorEdited":_vm.onCanvasColorEdited}}):_vm._e(),_vm._v(" "),(!_vm.selectedCanvas || !_vm.selectedCanvas.id)?_c('div',{staticClass:"h-100 no-canvas-selected"},[_c('h1',[_vm._v("No canvas selected")])]):_vm._e()],1),_vm._v(" "),_c('LoginDialog',{attrs:{"visible":_vm.isLogInDialogVisible},on:{"onClosed":function($event){_vm.onLoginDialogClosed()},"onLogedIn":_vm.onLogedIn}}),_vm._v(" "),_c('SignUpDialog',{attrs:{"visible":_vm.isSignUpDialogVisible},on:{"onClosed":function($event){_vm.onSignUpDialogClosed()},"onSignedUp":_vm.onSignedUp}}),_vm._v(" "),_c('UserSettingsDialog',{attrs:{"user":_vm.user,"visible":_vm.isUserSettingsVisible},on:{"onClosed":function($event){_vm.onUserSettingsClosed()},"onAccountDeleted":function($event){_vm.onAccountDeleted()}}}),_vm._v(" "),_c('KeyPartnersHelpDialog',{attrs:{"visible":_vm.selectedTopicHelp === 'key-partners'},on:{"onClosed":function($event){_vm.onCloseHelpDialog()}}}),_vm._v(" "),_c('KeyActivitiesHelpDialog',{attrs:{"visible":_vm.selectedTopicHelp === 'key-activities'},on:{"onClosed":function($event){_vm.onCloseHelpDialog()}}}),_vm._v(" "),_c('KeyResourcesHelpDialog',{attrs:{"visible":_vm.selectedTopicHelp === 'key-resources'},on:{"onClosed":function($event){_vm.onCloseHelpDialog()}}}),_vm._v(" "),_c('ValuePropositionsHelpDialog',{attrs:{"visible":_vm.selectedTopicHelp === 'value-propositions'},on:{"onClosed":function($event){_vm.onCloseHelpDialog()}}}),_vm._v(" "),_c('CustomerRelationshipsHelpDialog',{attrs:{"visible":_vm.selectedTopicHelp === 'customer-relationships'},on:{"onClosed":function($event){_vm.onCloseHelpDialog()}}}),_vm._v(" "),_c('ChannelsHelpDialog',{attrs:{"visible":_vm.selectedTopicHelp === 'channels'},on:{"onClosed":function($event){_vm.onCloseHelpDialog()}}}),_vm._v(" "),_c('CustomerSegmentsHelpDialog',{attrs:{"visible":_vm.selectedTopicHelp === 'customer-segments'},on:{"onClosed":function($event){_vm.onCloseHelpDialog()}}}),_vm._v(" "),_c('CostStructureHelpDialog',{attrs:{"visible":_vm.selectedTopicHelp === 'cost-structure'},on:{"onClosed":function($event){_vm.onCloseHelpDialog()}}}),_vm._v(" "),_c('RevenueStreamsHelpDialog',{attrs:{"visible":_vm.selectedTopicHelp === 'revenue-streams'},on:{"onClosed":function($event){_vm.onCloseHelpDialog()}}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"small underline"},[_c('strong',[_vm._v("All changes are permanently saved")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad"},[_c('p',[_vm._v("Top 2 para emprendedores 💰")]),_vm._v(" "),_c('div',{staticClass:"books"},[_c('a',{attrs:{"href":"https://amzn.to/2SeH2bl","target":"_blank"}},[_c('img',{attrs:{"src":"/static/fourhour.jpg","alt":"Jornada Laboral 4 horas"}})]),_vm._v(" "),_c('a',{attrs:{"href":"https://amzn.to/3btdPRz","target":"_blank"}},[_c('img',{attrs:{"src":"/static/padrerico.jpg","alt":"Padre Rico, Padre Pobre"}})])]),_vm._v(" "),_c('p',{staticClass:"notice"},[_vm._v("En calidad de Afiliado de Amazon, obtengo ingresos por las compras adscritas que cumplen los requisitos aplicables")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Canvas__ = __webpack_require__(129);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* unused harmony default export */ var _unused_webpack_default_export = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Canvas',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Canvas__["a" /* default */]
  }]
}));

/***/ }),
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 448 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[199]);


// WEBPACK FOOTER //
// static/js/app.b974b00fccfa72e7a6ec.js